import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ReportDropdownCoordinatorService {
  private readonly activeControlSubject = new BehaviorSubject<string | null>(null);

  readonly activeControl$ = this.activeControlSubject.asObservable();

  open(controlKey: string): void {
    this.activeControlSubject.next(controlKey);
  }

  close(controlKey?: string): void {
    if (!controlKey || this.activeControlSubject.value === controlKey) {
      this.activeControlSubject.next(null);
    }
  }
}
